export default {
    locationLoading: state => state.locationLoading,
    locationsListLoading: state => state.locationsListLoading,
    locationsList: state => state.locationsList,
}